<template>
    <section>
        <v-text-field
        ref="nombreEmpleo"
        label="Nombre de la empresa"
        prepend-icon="mdi-domain"
        v-model="empleo.nombre"
        ></v-text-field>
        <v-text-field
        label="Puesto ocupado"
        prepend-icon="mdi-briefcase-account"
        v-model="empleo.puesto"
        ></v-text-field>
        <v-text-field
        label="Periodo de trabajo"
        prepend-icon="mdi-calendar"
        v-model="empleo.periodo"
        ></v-text-field>
        <v-text-field
        label="Lugar"
        prepend-icon="mdi-google-maps"
        v-model="empleo.lugar"
        ></v-text-field>
        <v-textarea
        label="Escribe una pequeña descripción des las actividades realizadas"
        v-model="empleo.descripcion"
        ></v-textarea>
        <v-btn
          block
          dark
          :color="color"
          elevation="2"
          @click="agregarEmpleo"
        >
            <span v-if="editar">Aceptar</span>
            <span v-if="!editar">Añadir</span>
        </v-btn>
         <div v-if="empleos.length > 0">
            <tabla-datos
            :encabezado="encabezadoTabla" 
            :datos="empleos"
            @editar="editarEmpleo"
            @eliminar="eliminarEmpleo" 
            />   
        </div>
    </section>
</template>
<script>
    import TablaDatos from './TablaDatos'
    export default{
        name: "ExperienciaLaboral",
        components: { TablaDatos },

        data: ()=>({
            encabezadoTabla: [
                {
                  text: "Empleo",
                  value: "nombre",
                },
                {
                  text: "Puesto",
                  value: "puesto",
                },
                {
                  text: "Periodo",
                  value: "periodo",
                },
                {
                  text: "Lugar",
                  value: "lugar",
                },
                {
                  text: "Tareas",
                  value: "descripcion",
                },
                {
                  text: "Opciones",
                  value: "opciones",
                },
            ],
            empleos: [],
            empleo:{
                nombre: "",
                puesto: "",
                periodo: "",
                lugar:"",
                descripcion: ""
            },
            color: "indigo darken-4",
            editar: false,
            indice: -1,
        }),

        methods: {
            eliminarEmpleo(empleo){
                this.empleos.splice(this.empleos.indexOf(empleo), 1)
            },

            editarEmpleo(empleo){
                this.color = "secondary"
                this.editar = true
                this.empleo = empleo
                this.indice = this.empleos.indexOf(empleo)
            },

            agregarEmpleo(){
                 if(this.indice > -1){
                    Object.assign(this.empleos[this.indice], this.empleo)
                    this.editar = false
                    this.color = "indigo darken-4"
                    this.indice = -1
                } else {
                    this.empleos.push(this.empleo)
                }
                this.emitir()
                this.empleo = {
                    nombre: "",
                    puesto: "",
                    periodo: "",
                    lugar: "",
                    descripcion: ""
                }
                this.ponerFocus()
            },

            emitir(){
                this.$emit("empleo", this.empleos)
            },

            ponerFocus(){
                this.$refs["nombreEmpleo"].focus()
            }   
        }
    }
</script>